module.exports = __webpack_public_path__ + "static/media/santa_helena.f99c2738.jpg";